import * as Client from '../clients/DismissWinnerPopup';

/**
 * Service layer for dismissing the Best-in-Dental winner popup
 * Wraps the client call and handles business logic/error transformation
 * Backend automatically dismisses the most recent undismissed winner popup
 *
 * @returns Promise<void>
 */
export const dismissWinnerPopup = async (): Promise<void> => {
  await Client.dismissWinnerPopup();
};
